import type { CentralTheme, CentralThemeMode } from "./central-theme";

export type CentralThemePreference = "dark" | "light" | "system";

export function resolveCentralThemeMode(
  theme: CentralTheme,
  preference: CentralThemePreference,
  systemPrefersDark: boolean,
): CentralThemeMode {
  const mode = preference === "system" ? (systemPrefersDark ? "dark" : "light") : preference;
  return theme.modes[mode];
}

export function parseCentralThemePreference(value: unknown): CentralThemePreference {
  return value === "dark" || value === "light" ? value : "system";
}

export function centralThemeFontStack(font: string, fallback: "body" | "heading") {
  const safeFont = font.replace(/["'<>;]/g, "").trim().slice(0, 100);
  const fallbacks = fallback === "heading"
    ? 'Newsreader, Georgia, "Times New Roman", serif'
    : 'Manrope, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
  return safeFont ? `${safeFont}, ${fallbacks}` : fallbacks;
}
